import ContentstackLivePreview from '@contentstack/live-preview-utils';
import CSDataManager from './CSDataManager';

const activeEnv = process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || 'development';
const isPreview = activeEnv === 'preview';

const csDataManager =
  isPreview && typeof window !== 'undefined'
    ? new CSDataManager({
        region: 'eu',
        api_key: process.env.CONTENTSTACK_API_KEY as string,
        environment: process.env.CONTENTSTACK_ENVIRONMENT as string,
        branch: 'main',
        delivery_token: process.env.CONTENTSTACK_DELIVERY_TOKEN as string,
        live_preview: {
          preview_token: process.env.CONTENTSTACK_PREVIEW_TOKEN as string,
          enable: true,
          preview_host: 'eu-rest-preview.contentstack.com',
        },
        jsonRteToHtml: true,
      })
    : undefined;

export const initiateLivePreview = (): void => {
  if (isPreview && typeof window !== 'undefined' && csDataManager) {
    console.info('Initializing Live Preview...');
    csDataManager.setHost('https://eu-cdn.contentstack.com/v3');
    ContentstackLivePreview.init({
      ssr: false,
      stackSdk: csDataManager.stackSdk,
      /*  Indicates contentstack where the content will be previewed. By default, it's app.contentstack.com,
       which will end up previewing the website inside Contentstack's live preview frame. 
          For EU, the contentstack link is 'eu-app.contentstack.com', but we can also set an external host.*/
      clientUrlParams: {
        host: 'eu-app.contentstack.com',
      },
      editButton: {
        enable: true,
      },
    });
  }
};

export default csDataManager;
